<template>
  <div class="cadastro">
    <div id="voltar">
      <h4>Editar Tarefa</h4>
      <button @click.prevent="fecharForm()">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>

    <form
      class="form"
      @submit.prevent="atualizarTarefa($event)"
    >
      <div id="campos-form">
        <section id="esquerda">
          <div class="mb-3">
            <label
              for="titulo"
              class="form-label"
              >Título*</label
            >
            <HelpIcon :texto="textosAjuda[0]" />
            <input
              type="text"
              class="form-control"
              id="titulo"
              v-model="tarefa.titulo"
              required
            />
          </div>

          <div class="mb-3">
            <label
              for="descricao"
              class="form-label"
              >Descrição*</label
            >
            <HelpIcon :texto="textosAjuda[1]" />
            <textarea
              class="form-control"
              id="descricao"
              rows="3"
              v-model="tarefa.descricao"
              required
            ></textarea>
          </div>

          <div class="mb-3">
            <label
              for="modalidade-execucao"
              class="form-label"
              >Prioridade*</label
            >
            <HelpIcon :texto="textosAjuda[4]" />
            <select
              id="modalidade-execucao"
              class="form-select"
              v-model="tarefa.prioridade.id"
              required
            >
              <option
                v-for="prioridade in prioridades"
                :value="prioridade.id"
                :key="prioridade.id"
              >
                {{ formatarEnum(prioridade.prioridadeTarefa) }}
              </option>
            </select>
          </div>
        </section>

        <section id="direita">
          <div id="datas">
            <div class="mb-3">
              <label
                for="dataInicio"
                class="form-label"
                >Data de Início</label
              >
              <HelpIcon :texto="textosAjuda[2]" />
              <input
                type="datetime-local"
                id="dataInicio"
                class="form-control"
                v-model="tarefa.dataInicio"
              />
            </div>

            <div class="mb-3">
              <label
                for="dataFim"
                class="form-label"
                >Data de Fim</label
              >
              <HelpIcon :texto="textosAjuda[3]" />
              <input
                type="datetime-local"
                id="dataFim"
                class="form-control"
                v-model="tarefa.dataFim"
              />
            </div>
          </div>

          <div class="mb-3">
            <label
              for="tempoEstimado"
              class="form-label"
              >Tempo Estimado*</label
            >
            <HelpIcon :texto="textosAjuda[8]" />
            <input
              type="time"
              id="tempoEstimado"
              class="form-control"
              v-model="tempoEstimado"
              required
            />
          </div>

          <div class="mb-3">
            <label
              for="atividade-vinculada"
              class="form-label"
              >Atividade Vinculada</label
            >
            <HelpIcon :texto="textosAjuda[6]" />
            <div
              style="
                display: flex;
                justify-content: space-between;
                width: 100%;
                align-items: center;
                gap: 10px;
              "
            >
              <select
                id="atividade-vinculada"
                class="form-select"
                v-model="tarefa.atividadeId"
                @change="onAtividadeChange"
              >
                <option value="">Selecione uma atividade</option>
                <option
                  v-for="atividade in atividadesAcao"
                  :value="atividade.id"
                  :key="atividade.id"
                >
                  {{ atividade.nome }}
                </option>
              </select>
              <button
                id="remover-atividade"
                v-if="tarefa.atividadeId"
                @click.prevent="removerAtividadeVinculada"
              >
                Remover
              </button>
            </div>
          </div>

          <!-- Seção de Alocação de Membros - Condicional -->
          <div id="container-integrantes">
            <div class="mb-3">
              <div id="membros-card">
                <div id="label-help">
                  <label
                    for="exampleFormControlInput1"
                    class="form-label"
                    >Alocar Responsáveis</label
                  >
                  <HelpIcon :texto="textosAjuda[5]" />
                </div>

                <!-- Lista de membros já alocados (SOMENTE LEITURA) -->
                <div
                  v-if="usuariosAlocados.length > 0"
                  class="usuarios-alocados"
                >
                  <p style="margin-bottom: 10px; color: var(--cinza-escuro)">
                    <small>Membros já alocados</small>
                  </p>
                  <div class="lista-alocados">
                    <div
                      v-for="usuario in usuariosAlocados"
                      :key="usuario.id"
                      class="usuario-alocado"
                    >
                      <span>{{ formatarEnum(usuario.nome) }}</span>
                      <span class="badge-alocado">Já alocado</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Quando há atividade vinculada -->
              <div
                v-if="tarefa.atividadeId && equipeFiltrada.length > 0"
                class="grupo-atividade"
              >
                <p style="margin-bottom: 10px; color: var(--cinza-escuro)">
                  <small
                    >Membros disponíveis da equipe (seleção múltipla):</small
                  >
                </p>
                <div class="membros-lista">
                  <div
                    v-for="membro in equipeFiltrada"
                    :key="membro.id"
                    class="membro-item"
                  >
                    <label class="membro-checkbox">
                      <input
                        type="checkbox"
                        :value="membro.id"
                        v-model="membrosSelecionados"
                        @change="atualizarMembrosDaAtividade"
                      />
                      <span>{{ membro.nome }}</span>
                    </label>
                  </div>
                </div>
                <p
                  v-if="membrosSelecionados.length > 0"
                  class="info-selecionados"
                >
                  {{ membrosSelecionados.length }} membro(s) selecionado(s)
                </p>
              </div>

              <!-- Quando não há atividade vinculada -->
              <div
                v-if="!tarefa.atividadeId || equipeFiltrada.length <= 0"
                style="
                  display: flex;
                  gap: 10px;
                  align-items: center;
                  width: 100%;
                "
              >
                <select
                  id="integrantesAcao"
                  class="form-select"
                  v-model="integranteSelecionado"
                >
                  <option value="">Selecione um membro</option>
                  <option
                    v-for="integrante in integrantesDisponiveis"
                    :value="integrante"
                    :key="integrante.id"
                  >
                    {{ integrante.nome }}
                  </option>
                </select>
                <button
                  type="button"
                  id="adicionar-integrante"
                  @click="adicionarIntegrante"
                  :disabled="!integranteSelecionado.id"
                >
                  Adicionar
                </button>
              </div>
            </div>
            <div
              v-if="novosUsuarios.length > 0"
              class="lista-membros-selecionados"
            >
              <h6>Membros selecionados</h6>
              <div
                class="integrante-selecionado"
                v-for="(usuario, index) in novosUsuarios"
                :key="usuario.id"
              >
                <div>{{ usuario.nome }}</div>
                <button
                  type="button"
                  class="remover-integrante"
                  @click.prevent="removerIntegrante(usuario)"
                >
                  Remover
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div id="botoes">
        <button
          id="cancelar"
          type="button"
          @click.prevent="
            ((texto = 'Você deseja realmente cancelar a tarefa?'),
            (confirmacao = true))
          "
        >
          Cancelar
        </button>
        <button
          type="submit"
          name="acao"
          value="GRAVAR"
          id="enviar"
        >
          Gravar
        </button>
        <button
          type="submit"
          name="acao"
          value="ENVIAR"
          id="enviar"
        >
          Enviar
        </button>
      </div>
    </form>
  </div>
  <ModalDeConfirmacao
    v-if="confirmacao == true"
    @confirmacao="emitConfirmacao"
    :texto="texto"
  ></ModalDeConfirmacao>
  <Aviso
    v-if="aviso == true"
    @fecharModal="aviso = false"
    :texto="texto"
    :sucesso="sucesso"
  ></Aviso>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, computed } from "vue";
import HelpIcon from "@/components/common/HelpIcon.vue";
import {
  formatarEnum,
  formatarParaInputDateTimeLocal,
} from "@/utils/FormatarEntradas";
import atividadeService from "@/service/atividadeService";
import acaoService from "@/service/acaoService";
import tarefaService from "@/service/tarefaService";
import ModalDeConfirmacao from "@/components/common/modalDeConfirmacao.vue";
import Aviso from "@/components/common/aviso.vue";
import router from "@/router";

const { proxy } = getCurrentInstance();

const emit = defineEmits(["fecharFormEdicao"]);

const props = defineProps({
  tarefa: {
    type: Object,
    required: true,
  },
  acaoId: {
    type: String,
    required: true,
  },
});

const textosAjuda = [
  "Informe um título claro e objetivo para a notícia. Exemplos: 'Novo curso de extensão é ofertado', 'Evento arrecada mais de 1000kg de alimentos'",
  "Descreva o conteúdo completo da tarefa. Inclua informações relevantes, o que será importatnte nessa tarefa",
  "Data de Início da tarefa e fim, as pessoas só poderam responder dentro desse intervalo",
  "Data de Início da tarefa e fim, as pessoas só poderam responder dentro desse intervalo",
  "O quão importante é responder essa tarefa, definindo pela prioridade",
  "Selecione qual o público específico quer atingir e que poderá responder",
  "Em qual tópico ela será postada, no caso só há a opção de 'Atividades'",
  "Em que status está a tarefa, se poderá ser respondida, ou informa que está em edição.",
  "Tempo em horas que o coordenador estima para que a tarefa possa ser concluída",
  "Indica qual o estado da tarefa, Para fazer ou em edição(Quando você ainda não concluiu o cadastro e quer salvar para concluir depois)",
];

const prioridades = ref([]);
const integrantesAcao = ref([]);
const integranteSelecionado = ref({});
const atividadesAcao = ref([]);
const tempoEstimado = ref(minutosParaHorasString(props.tarefa.tempoEstimado));
const equipe = ref([]);
const membrosSelecionados = ref([]);
const usuariosAlocadosInicial = ref([]);
const confirmacao = ref(false);
const texto = ref("");
const aviso = ref(false);
const sucesso = ref(false);
const tarefa = ref({
  titulo: props.tarefa.titulo,
  descricao: props.tarefa.descricao,
  dataInicio: formatarParaInputDateTimeLocal(props.tarefa.dataInicio),
  dataFim: formatarParaInputDateTimeLocal(props.tarefa.dataFim),
  tempoEstimado: props.tarefa.tempoEstimado,
  prioridade: {
    id: props.tarefa.id,
    prioridade: props.tarefa.prioridadeDescricao,
  },
  atividadeId: props.tarefa.atividadeId || "",
  acaoId: props.acaoId,
  listaUsuarios: [],
});

// Computed para usuários já alocados (somente leitura)
const usuariosAlocados = computed(() => {
  return usuariosAlocadosInicial.value;
});

// Computed para NOVOS usuários (que podem ser removidos)
const novosUsuarios = computed(() => {
  return tarefa.value.listaUsuarios.filter(
    (user) =>
      !usuariosAlocadosInicial.value.some((alocado) => alocado.id === user.id)
  );
});

// Computed para equipe filtrada (remove usuários já alocados)
const equipeFiltrada = computed(() => {
  return equipe.value.filter(
    (membro) =>
      !usuariosAlocadosInicial.value.some(
        (alocado) => alocado.nome === membro.nome
      )
  );
});

// Computed para integrantes disponíveis (quando não há atividade vinculada)
const integrantesDisponiveis = computed(() => {
  return integrantesAcao.value.filter(
    (integrante) =>
      !tarefa.value.listaUsuarios.some(
        (user) => user.nome == integrante.nome
      ) &&
      !usuariosAlocadosInicial.value.some(
        (alocado) => alocado.nome == integrante.nome
      )
  );
});
function emitConfirmacao(valor) {
  confirmacao.value = false;
  if (valor == true) {
    cancelarTarefa();
  } else {
    texto.value = "Tarefa não cancelada!";
    aviso.value = true;
  }
}
async function buscarEquipe() {
  if (!tarefa.value.atividadeId) {
    equipe.value = [];
    membrosSelecionados.value = [];
    return;
  }

  try {
    const response = await atividadeService.getGrupoAtividade(
      tarefa.value.atividadeId
    );
    if (response.status === 200) {
      equipe.value = response.data.Membros || [];

      // Inicializa os membros selecionados apenas com os NOVOS usuários
      membrosSelecionados.value = novosUsuarios.value
        .filter((user) => equipe.value.some((membro) => membro.id === user.id))
        .map((user) => user.id);
    } else {
      equipe.value = [];
      alert(
        "Grupo da atividade não foi encontrado, mas selecione as pessoas que automaticamente irão compor o grupo da atividade!"
      );
    }
  } catch (error) {
    console.error("Erro ao buscar equipe:", error);
    equipe.value = [];
  }
}

function onAtividadeChange() {
  buscarEquipe();
  // Limpa apenas os NOVOS usuários quando muda a atividade
  tarefa.value.listaUsuarios = [...usuariosAlocadosInicial.value];
  membrosSelecionados.value = [];
}

function removerAtividadeVinculada() {
  tarefa.value.atividadeId = "";
  equipe.value = [];
  membrosSelecionados.value = [];
  // Mantém os usuários já alocados, remove apenas os novos
  tarefa.value.listaUsuarios = [...usuariosAlocadosInicial.value];
}

function atualizarMembrosDaAtividade() {
  // Combina usuários já alocados com novos selecionados
  const novosMembros = equipe.value
    .filter((membro) => membrosSelecionados.value.includes(membro.id))
    .map((membro) => ({ id: membro.id, nome: membro.nome }));

  tarefa.value.listaUsuarios = [
    ...usuariosAlocadosInicial.value,
    ...novosMembros,
  ];
}

function adicionarIntegrante() {
  if (integranteSelecionado.value.id) {
    tarefa.value.listaUsuarios.push({
      id: integranteSelecionado.value.id,
      nome: integranteSelecionado.value.nome,
    });
    integranteSelecionado.value = {};
  }
}

function removerIntegrante(integrante) {
  // Só permite remover NOVOS usuários, não os já alocados
  const newArray = tarefa.value.listaUsuarios.filter(
    (user) => user.id != integrante.id
  );
  tarefa.value.listaUsuarios = newArray;
}

async function atualizarTarefa(evento) {
  // Validação básica

  const botao = evento.submitter?.value;
  tarefa.value.tempoEstimado = horasParaMinutos(tempoEstimado.value);

  if (!tarefa.value.atividadeId) {
    tarefa.value.acaoId = props.acaoId;
  }

  const usersTarefa = [];
  if (tarefa.value.listaUsuarios.length !== 0) {
    integrantesAcao.value.map((integrante) => {
      tarefa.value.listaUsuarios.map((user) => {
        if (integrante.nome == user.nome) {
          usersTarefa.push(integrante.id);
        }
      });
    });
  }
  const dadosTarefa = {
    ...tarefa.value,
    listaUsuarios: usersTarefa,
  };

  const response = await tarefaService.putTarefa(
    props.tarefa.id,
    botao,
    dadosTarefa
  );
  if (response.status >= 400) {
    // var erros = "";
    // response.data.errors.map((erro) => (erros += ` ${erro.message}`));

    // alert(`erros na requisição: ${erros}`);
    texto.value = "Erro ao editar a tarefa, verifique os dados enviados!";
    sucesso.value = false;
    aviso.value = true;
  }
  if (response.status == 200) {
    texto.value = "Tarefa editada com sucesso!";
    sucesso.value = true;
    aviso.value = true;
  }
}

function minutosParaHorasString(minutos) {
  const horas = Math.floor(minutos / 60);
  const mins = minutos % 60;
  const formatoHoras = String(horas).padStart(2, "0");
  const formatoMinutos = String(mins).padStart(2, "0");
  return `${formatoHoras}:${formatoMinutos}`;
}

function horasParaMinutos(horaStr) {
  const [horas, minutos] = horaStr.split(":").map(Number);
  return horas * 60 + minutos;
}

async function cancelarTarefa() {
  const response = await tarefaService.cancelarTarefa(props.tarefa.id);
  if (!response) {
    texto.value = `Ocorreu algum erro ao cancelar a tarefa!`;
    aviso.value = true;
    return;
  }
  if (response.status == 200) {
    texto.value = "Tarefa cancelada com sucesso!";
    aviso.value = true;
    return;
  } else {
    texto.value = `Ocorreu algum erro ao cancelar a tarefa!`;
    aviso.value = true;
    return;
  }
}

function fecharForm() {
  router.push(-1);
}

onMounted(async () => {
  try {
    integrantesAcao.value = await acaoService.getIndiceDeCarga(
      props.acaoId,
      "LEVE"
    );
    const response = await atividadeService.getAtividadesAcao(
      0,
      1000,
      props.acaoId,
      false
    );
    atividadesAcao.value = response.filter(
      (atividade) => atividade.acaoUrl.split("/").pop() == props.acaoId
    );
    prioridades.value = await tarefaService.getPrioridadeTarefa();

    const prioridadeCorrespondente = prioridades.value.find(
      (p) => p.prioridadeTarefa === props.tarefa.prioridadeDescricao
    );
    if (prioridadeCorrespondente) {
      tarefa.value.prioridade.id = prioridadeCorrespondente.id;
    }

    // Corrigindo a inicialização dos usuários já alocados
    usuariosAlocadosInicial.value = [];
    props.tarefa.usuariosNomes?.forEach((nomeUsuario, index) => {
      const usuarioEncontrado = integrantesAcao.value.find(
        (user) => user.nome === nomeUsuario
      );
      if (usuarioEncontrado) {
        usuariosAlocadosInicial.value.push({
          nome: usuarioEncontrado.nome,
          id: usuarioEncontrado.id,
        });
      }
    });

    // Inicializa a lista de usuários com os já alocados
    tarefa.value.listaUsuarios = [...usuariosAlocadosInicial.value];

    // Busca a equipe se já houver atividade vinculada
    if (tarefa.value.atividadeId) {
      await buscarEquipe();
    }
  } catch (error) {
    console.error("Erro ao carregar dados:", error);
  }
});
</script>
<style scoped>
#label-help {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
#membros-card {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.usuarios-alocados {
  margin-bottom: 20px;
  padding: 15px;
  background-color: var(--branco);
  border-radius: 8px;
  border-left: 4px solid var(--roxo-medio);
}

.lista-alocados {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.usuario-alocado {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: var(--branco);
  border-radius: 6px;
  border: 1px solid var(--cinza-claro);
  font-size: 15px;
}

.badge-alocado {
  background-color: var(--roxo-medio);
  color: var(--branco);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7em;
  font-weight: bold;
}

/* Destaque para a seção de novos usuários */
.lista-membros-selecionados {
  margin-top: 15px;
  padding: 15px;
  background-color: var(--verde-claro);
  border-radius: 8px;
  border-left: 4px solid var(--verde);
}

.lista-membros-selecionados h6 {
  margin-bottom: 10px;
  color: var(--verde-escuro);
  font-weight: bold;
}

.mb-3 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.campos-form {
  padding-bottom: 40px;
}

#atividade-vinculada {
  flex: 1;
}

#remover-atividade {
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}

.grupo-atividade {
  margin-top: 10px;
  width: 100%;
}

.membros-lista {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.membro-item {
  display: flex;
  align-items: center;
}

.membro-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.membro-checkbox input[type="checkbox"] {
  margin: 0;
}

.info-selecionados {
  margin-top: 10px;
  padding: 8px;
  background-color: var(--cinza-claro);
  border-radius: 4px;
  font-size: 0.9em;
}

.lista-membros-selecionados {
  margin-top: 15px;
}

.lista-membros-selecionados h6 {
  margin-bottom: 10px;
  color: var(--cinza-escuro);
}

.integrante-selecionado {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 5px;
  border-bottom: 2px solid hsla(0, 0%, 0%, 0.186);
}

#adicionar-integrante {
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}

#adicionar-integrante:disabled {
  background-color: var(--cinza-claro);
  cursor: not-allowed;
}

.remover-integrante {
  background-color: var(--vermelho);
  color: var(--branco);
  border: none;
  padding: 5px 10px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.8em;
}

#cancelar {
  background-color: var(--vermelho);
  border-color: var(--vermelho);
  color: var(--branco);
}
</style>
